import type React from "react"

import { useFormatCurrency } from "@/formatters"

import type { ComplianceFinesProps } from "./compliance-fines.types"

export const ComplianceFines: React.FC<ComplianceFinesProps> = ({
  regulations,
}) => {
  const { formatCurrency } = useFormatCurrency({
    precision: 0,
  })

  const fines: number | null =
    regulations?.reduce((total: number | null, regulation) => {
      if (
        !Number.isFinite(total) &&
        (regulation.regulation_name === "No Regulation" ||
          regulation.is_supported_without_fines)
      ) {
        return null
      }

      if (!Number.isFinite(total)) {
        return regulation.penalties
      }

      return (total ?? 0) + regulation.penalties
    }, null) ?? null

  return <>{!regulations?.length ? "--" : formatCurrency(fines)}</>
}
